var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7499 23.5254H8.24992C3.27242 23.5254 1.14575 21.2054 1.14575 15.7754V9.77539C1.14575 4.34539 3.27242 2.02539 8.24992 2.02539H12.8333C13.2091 2.02539 13.5208 2.36539 13.5208 2.77539C13.5208 3.18539 13.2091 3.52539 12.8333 3.52539H8.24992C4.02409 3.52539 2.52075 5.16539 2.52075 9.77539V15.7754C2.52075 20.3854 4.02409 22.0254 8.24992 22.0254H13.7499C17.9758 22.0254 19.4791 20.3854 19.4791 15.7754V10.7754C19.4791 10.3654 19.7908 10.0254 20.1666 10.0254C20.5424 10.0254 20.8541 10.3654 20.8541 10.7754V15.7754C20.8541 21.2054 18.7274 23.5254 13.7499 23.5254Z",
    fill: "#8DC63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1666 11.5254H16.4999C13.3649 11.5254 12.1458 10.1954 12.1458 6.77538V2.77538C12.1458 2.47538 12.3108 2.19538 12.5674 2.08538C12.8241 1.96538 13.1174 2.03538 13.3191 2.24538L20.6524 10.2454C20.8449 10.4554 20.9091 10.7854 20.7991 11.0654C20.6891 11.3454 20.4416 11.5254 20.1666 11.5254ZM13.5208 4.58538V6.77538C13.5208 9.35538 14.1349 10.0254 16.4999 10.0254H18.5074L13.5208 4.58538Z",
    fill: "#8DC63F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 14.5254H6.41675C6.04091 14.5254 5.72925 14.1854 5.72925 13.7754C5.72925 13.3654 6.04091 13.0254 6.41675 13.0254H11.9167C12.2926 13.0254 12.6042 13.3654 12.6042 13.7754C12.6042 14.1854 12.2926 14.5254 11.9167 14.5254Z",
    fill: "#8DC63F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0834 18.5254H6.41675C6.04091 18.5254 5.72925 18.1854 5.72925 17.7754C5.72925 17.3654 6.04091 17.0254 6.41675 17.0254H10.0834C10.4592 17.0254 10.7709 17.3654 10.7709 17.7754C10.7709 18.1854 10.4592 18.5254 10.0834 18.5254Z",
    fill: "#8DC63F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.ae6a49a3dbf66fa54cda6f810739d23e.svg";
export { ForwardRef as ReactComponent };